<template>
  <Main>
    <SelectPolicy v-if="!policy" @select="updatePolicy" />
    <RequestEndorsementSelectedPolicy v-else />
  </Main>
</template>
<script>
import SelectPolicy from "../components/SelectPolicy.vue";
import RequestEndorsementSelectedPolicy from "../components/RequestEndorsementSelectedPolicy.vue";
export default {
  data: () => ({
    policy: null
  }),
  components: { SelectPolicy, RequestEndorsementSelectedPolicy },
  methods: {
    updatePolicy(item) {
      this.$router.replace({
        name: "new request endorsement request",
        params: { id: item.id }
      });
      this.policy = item;
    }
  }
};
</script>
